<template>
  <b-modal
    id="modal-all-employee-present"
    hide-header
    hide-footer
    centered
  >
    <div class="text-center">
      <img src="@/assets/close_up.png" />
    </div>
    <h4 class="text-danger font-weight-bold text-center">All Employee Present</h4>
    <div class="text-center">Are you sure that all employee is present?</div>
    <div class="mt-3 d-flex justify-content-center">
      <b-button
        class="text-warning"
        variant="outline-warning"
        @click="onClickBack"
      >
        No, Cancel
      </b-button>
      <b-button
        class="next ml-3"
        variant="warning"
        @click="allPresent"
      >
        All Present
      </b-button>
    </div>
  </b-modal>
</template>
<script>

export default {
  methods: {
    onClickBack() {
      this.$bvModal.hide('modal-all-employee-present')
    },
    allPresent() {
      this.$bvModal.hide('modal-all-employee-present')
      this.$emit('allPresent')
    }
  }
}
</script>
